import { IUploadFile } from "@/models/IUploadFile";

import { BaseRepository } from "@/repositories/BaseRepository";

class UploadFileRepository extends BaseRepository<IUploadFile> {
    constructor() {
        super("/Activations/MergeUpload");
    }
}

const uploadFileRepository = new UploadFileRepository();

export { UploadFileRepository, uploadFileRepository };
